<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { fade } from "svelte/transition";
  import Spinner from "./Spinner.svelte";
  import { wishlistFavorites } from '../wishlist';

  export let productTitle;

  const dispatch = createEventDispatcher();

  let mask, isLoading;
  let products = [];
  let currentHeader = null;

  if (!window.digi_object) {
    window.digi_object = {};
    window.digi_object.rest_url = "http://localhost/digibord-shop.nl/wp-json/digi/v1";
    window.digi_object.site_url = "http://localhost/digibord-shop.nl";
  }

  onMount(() => {
    document.body.classList.toggle("modal-is-open");

    isLoading = true;

    fetchProducts().then(response => {
      isLoading = false;
      console.log(response);
      products = response;
    });
  });

  async function fetchProducts() {
    const storage = localStorage.getItem("products");

    if (JSON.parse(storage).length > 0) {
      isLoading = true;

      const response = await fetch(`${window.digi_object.rest_url}/products`, {
        method: "POST",
        body: JSON.stringify({ products: JSON.parse(storage) }),
        headers: {
          'Content-Type': 'application/json'
        }
      });

      return await response.json();
    } else {
      return [];
    }
  }

  function handleItemDeletion(e) {
    console.log(this);
    const product_id = parseInt(this.getAttribute('data-product_id'))
    const product_title = this.getAttribute('data-product_title');
    console.log(product_id);
    wishlistFavorites(this, product_id);

    currentHeader = {
      type: "deleted",
      title: product_title
    }

    products = products.filter(_product => {
      return _product.id !== product_id;
    });

    if (products.length === 0) {
      dispatch('close');
    }
  }

  function handleMaskClick(e) {
    if (event.target === mask) {
      dispatch("close");
    }
  }
</script>

<style lang="scss">
  .modal-mask {
    position: fixed;
    z-index: 9999999999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    margin: auto;
    justify-content: center;
    align-items: center;
  }

  .modal-container {
    width: auto;
    min-width: 43em;
    background: #fff;
    border-radius: 15px;
    position: relative;
    font-family: "Rubik", sans-serif !important;
  }

  .close-modal-button {
    position: absolute;
    right: 10px;
    top: 10px;

    :global(svg) {
      width: 20px;
      cursor: pointer;
      stroke: red;
    }
  }

  .modal-header {
    padding: 15px;
    border-radius: 15px;

    h2 {
      font-size: 18px;
      padding-right: 15px;
      font-weight: bold;
      color: #26cb01;
      display: flex;
      align-items: center;
      justify-content: center;

      :global(svg) {
        width: 24px;
        margin-right: 10px;
      }
    }

    h2.deleted {
      color: #fb5d13;
    }
  }

  .modal-body {
    padding: 15px 35px;

    .modal-items {
      list-style: none;
      padding-left: 0;

      .title {
        font-weight: bold;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
      }

      .loading {
        margin-top: 15px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
      }

      .product {
        padding-top: 15px;
        padding-bottom: 15px;
        display: flex;

        align-items: center;

        .product-image {
          :global(img) {
            width: 100px;
            height: 60px;
            object-fit: contain;
          }
        }

        a {
          padding-left: 15px;
          flex: 1;
        }
      }

      .product:not(:last-child) {
        border-bottom: 1px solid #e6e6e6;
      }
    }
  }

  .modal-footer {
    padding: 15px 35px;

    button {
      background: #6ac1e4;
      font-size: 16px;
      font-weight: 500;
      text-transform: lowercase;
      border: none;
      color: #fff;
      padding: 1.1rem 2rem 1rem;
      font-family: 'Rubik', sans-serif;
      border-radius: 5px;
      margin-right: 15px;
      letter-spacing: 0.5px;
    }

    a {
      font-size: 16px;
      margin-left: 15px;
      color: #26cb01;
    }
  }

  .product-delete-item {
    background: transparent !important;
    border-radius: 100%;
    padding: 2px !important;
    margin-left: 10px;
    display: flex;

    &:hover {
      background: transparent !important;
      box-shadow: unset !important;
    }

    :global(svg) {
      width: 24px;
      stroke: red;
    }
  }

  @media (max-width: 991px) {

    .modal-mask {
        height: 100%;
        width: 90%;
        left: 0;
        margin: 0;
        background: #fff;
        display: block;

        &::before {
            content: '';
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            margin: auto;
            justify-content: center;
            align-items: center;

        }
    }

    .modal-container {
     width: 95%;
      height: 100%;
      right: unset;
      top: unset;
      display: flex;
      flex-flow: column;
      overflow: auto;
      position: relative;
      padding: 0;
      margin: 0;
      border-radius: 0;
      min-width: 0;

      &__title {
          height: 75px;
      }

      .modal-body {
          height: 50%;
          border-bottom: none !important;
          padding: 10px !important;

          h3 {
              margin-bottom: 20px;
              background: #1081c4;
              color: #fff;
              padding: 15px 0;
              font-size: 14px;
              text-align: center;
              margin: 0 0px 0 -10px;

              svg {
                  display: none;
              }

              span {
                margin-left: 0;
              }

              button.close-button {
                background: none;
                border: none;
                position: absolute;
                right: 10px;
                top: 3px;

                svg {
                  display: block;
                  fill: #fff;
                  width: 1.5rem;
                  height: 1.5rem;
                }
              }
          }
      }
     
      .modal-footer {
          padding: 20px 25px;          
          flex-wrap: unset;
          justify-content: flex-start;
      }
    }
  }
</style>

<div
  class="modal-mask"
  transition:fade={{ duration: 250 }}
  bind:this={mask}
  on:click|stopPropagation={handleMaskClick}>
  <div class="modal-container">
    <div on:click={() => dispatch('close')} class="close-modal-button">
      <svg class="icon icon--size-4 icon--color-white" aria-hidden="true" viewBox="0 0 19 19" focusable="false"><path transform="rotate(45 9.5 9.5)" d="M0 9.5c0-1 1-2 2-2h5.5V2c0-1 1-2 2-2s2 1 2 2v5.5H17c1 0 2 1 2 2s-1 2-2 2h-5.5V17c0 1-1 2-2 2s-2-1-2-2v-5.5H2c-1 0-2-1-2-2z"></path></svg>
    </div>

    <div class="modal-header">
      {#if currentHeader}
        <h2 class="deleted">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
          </svg>
          {currentHeader.title} is van uw offerte afgehaald
        </h2>
      {:else}
        <h2>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
            <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
          </svg>
          {productTitle} is toegevoegd aan uw offerte
        </h2>
      {/if}

    </div>
 
    <div class="modal-body">
      <ul class="modal-items">
        <li class="title">Mijn offerte</li>
        {#if isLoading}
          <li class="loading">
            <Spinner />
          </li>
        {:else}
          {#each products as product}
            <li class="product">
              <div class="product-image">
                {@html product.image}
              </div>
              <a href={product.link}>{product.title}</a>
              <span>€ {product.price}</span>
              <div>
                <button class="product-delete-item" data-product_title={product.title} data-product_id={product.id} on:click|stopPropagation|preventDefault={handleItemDeletion}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                  </svg>
                </button>
              </div>
            </li>
          {/each}
        {/if}
      </ul>
    </div>

    <div class="modal-footer">
      <button on:click={() => dispatch('close')}>Verder winkelen</button>
      <span>of <a href={`${window.digi_object.site_url}/offerte-aanvragen`}>offerte afronden</a></span>
    </div>
  </div>
</div>
